import { Button } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import TextField from "@material-ui/core/TextField";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import React from "react";
import firebase from "../../../../firebase";
import Roles from "./Roles";
import SnackBar from "./SnackBar";
import styles from "./styles";

const firebase2 = require("firebase");
require("firebase/firestore");

class Usuarios extends React.Component {
  constructor() {
    super();
    this.state = {
      guardado: false,
      exito: true,
      status: true,
      open2: false,
      err: null,
      text: "",
      tipoU: "",
      email: "",
      contra: "",
      contra2: "",
      open: false,
      isEdit: false,
      idElem: "",
      searchTerm: "",
      seccion: "tribunales",
      indexTab: 0,
      bancos: null,
      deCanela: null,
      rolLabel: "cliente",
      rol: [
        {
          value: "administrador",
          label: "administrador",
        },
        {
          value: "operador",
          label: "operador",
        },
        {
          value: "capturista",
          label: "capturista",
        },
        {
          value: "cliente",
          label: "cliente",
        },
      ],
    };
  }

  componentDidMount = async () => {
    firebase2
      .firestore()
      .collection("rol")
      .orderBy("id", "asc")
      .onSnapshot((serverUpdate) => {
        const deCanela = serverUpdate.docs.map((_doc) => {
          const data = _doc.data();
          data["id"] = _doc.id;
          return data;
        });

        this.setState({ deCanela });
      });

    firebase2
      .firestore()
      .collection("usuarios")
      .orderBy("nombre", "asc")
      .onSnapshot((serverUpdate) => {
        const bancos = serverUpdate.docs.map((_doc) => {
          const data = _doc.data();
          data["id"] = _doc.id;
          return data;
        });
        this.setState({ bancos });
      });
  };

  updateInactivo = (e) => {
    //this.setState({status: !this.state.status})
    firebase2.firestore().collection("usuarios").doc(e.id).update({
      nombre: e.nombre,
      email: e.email,
      rol: e.rol,
      contra: e.contra,
      status: !e.status,
    });
  };

  handleChange = (e) => {
    this.setState({ nombre: e.target.value });
  };

  newEntry = async () => {
    this.setState({ open: true });
  };

  handleAdd = async (e) => {
    e.preventDefault();
    /*if (this.state.isEdit) {
      firebase.edit(
        this.state.nombre,
        this.state.email,
        this.state.rolLabel,
        this.state.contra
      );

      firebase2
        .firestore()
        .collection("usuarios")
        .doc(this.state.idElem)
        .update({
          nombre: this.state.nombre,
          email: this.state.email,

          rol: this.state.rolLabel,
          contra: this.state.contra
        });*/

    try {
      const f = await firebase.register(
        this.state.nombre,
        this.state.email,
        this.state.contra,
        this.state.rolLabel
      );
      this.setState({ guardado: true, exito: f });
    } catch (error) {
      console.log(error.message);
    }

    this.setState({
      nombre: "",
      email: "",
      tipoU: "",
      isEdit: false,
      idElem: "",
      open: false,
    });
  };

  handleClose = () => {
    this.setState({
      nombre: "",
      email: "",
      tipoU: "",
      contra: "",
      contra2: "",
      isEdit: false,
      idElem: "",
      open: false,
    });
  };

  handleClose2 = () => {
    this.setState({
      nombre: "",
      email: "",
      tipoU: "",
      contra: "",
      contra2: "",
      nombreE: "",
      emailE: "",
      tipoUE: "",
      contraE: "",
      contra2E: "",
      isEdit: false,
      idElem: "",
      open2: false,
    });
  };

  editUser = async (note, e) => {
    e.preventDefault();
    this.setState({
      nombre: note.nombre,
      email: note.email,
      tipoU: note.tipoU,
      contra: note.contra,
      contra2: note.contr2,
      rolLabel: note.rol,
      nombreE: note.nombre,
      emailE: note.email,
      tipoUE: note.tipoU,
      contraE: note.contra,
      contra2E: note.contr2,
      rolLabelE: note.rol,
      isEdit: true,
      idElem: note.id,
      open2: true,
    });
  };

  editSubmit = async (e) => {
    e.preventDefault();

    firebase.edit(
      this.state.nombre,
      this.state.email,
      this.state.rolLabel,
      this.state.contra,
      this.state.nombreE,
      this.state.emailE,
      this.state.rolLabelE,
      this.state.contraE
    );

    firebase2.firestore().collection("usuarios").doc(this.state.idElem).update({
      nombre: this.state.nombreE,
      email: this.state.emailE,
      rol: this.state.rolLabelE,
      contra: this.state.contraE,
    });

    this.handleClose2();
  };

  deleteUser = async (id, email, password) => {
    console.log(email, password);
    firebase.delete(email, password);
    firebase2.firestore().collection("usuarios").doc(id).delete();
  };

  render() {
    const { classes } = this.props;

    const datos = this.state.bancos
      ? this.state.bancos.filter((task) => task.email !== "admin@admin.com")
      : null;

    return (
      <div>
        <div style={{ spacing: "15px" }}>
          <h1> Usuarios </h1>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {this.state.indexTab == 0 ? (
              <Button
                variant="contained"
                color="primary"
                onClick={this.newEntry}
                className={classes.button}
                endIcon={<AddIcon />}
              >
                Nuevo
              </Button>
            ) : null}
          </div>
        </div>
        <Paper square style={{ width: "100%", marginTop: "10px" }}>
          <Tabs
            value={this.state.indexTab}
            // onChange={handleChange}
            indicatorColor="secondary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab
              label="Usuarios"
              onClick={() =>
                this.setState({ indexTab: 0, seccion: "usuarios" })
              }
            />

            <Tab
              label="Privilegios"
              onClick={() =>
                this.setState({ indexTab: 1, seccion: "privilegios" })
              }
            />
          </Tabs>
        </Paper>
        {this.state.indexTab === 0 ? (
          <div>
            <List>
              <Card>
                <ListItem alignItems="flex-start">
                  <div className={classes.textSection}>
                    <h4
                      className={classes.itemText}
                      style={{ width: "25%", color: "#1506A5" }}
                    >
                      Nombre Usuario
                    </h4>
                    <h4
                      className={classes.itemText}
                      style={{ width: "25%", color: "#1506A5" }}
                    >
                      Rol
                    </h4>
                    <h4
                      className={classes.itemText}
                      style={{ width: "25%", color: "#1506A5" }}
                    >
                      Status
                    </h4>
                    <h4
                      className={classes.itemText}
                      style={{ width: "25%", color: "#1506A5" }}
                    >
                      Editar
                    </h4>
                  </div>
                </ListItem>
              </Card>
            </List>
            {datos ? (
              <List>
                {datos.map((item, _index) => {
                  return (
                    <Card key={_index} className={classes.card}>
                      <ListItem alignItems="flex-start">
                        <div className={classes.textSection}>
                          <h4
                            className={classes.itemText}
                            style={{ width: "25%", fontWeight: "100" }}
                          >
                            {item.nombre}
                          </h4>
                          <h4
                            className={classes.itemText}
                            style={{
                              width: "25%",
                              fontWeight: "100",
                              textTransform: "capitalize",
                            }}
                          >
                            {item.rol}
                          </h4>
                          <h4
                            className={classes.itemText}
                            style={{ width: "25%" }}
                          >
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={item.status}
                                    onClick={() => this.updateInactivo(item)}
                                    color="primary"
                                  />
                                }
                                label={item.status ? "Activado" : "Desactivado"}
                              />
                            </FormGroup>
                          </h4>
                          <div
                            className={classes.itemText}
                            style={{ width: "25%", fontWeight: "100" }}
                          >
                            <EditIcon
                              onClick={(e) => {
                                this.editUser(item, e);
                              }}
                              className={classes.editIcon}
                            />

                            {/*    <DeleteIcon
                              onClick={() =>
                                this.deleteUser(
                                  item.id, 
                                  item.email,
                                  item.contra  
                                )
                              }
                              className={classes.deleteIcon}
                            />*/}
                          </div>
                        </div>
                      </ListItem>
                    </Card>
                  );
                })}
              </List>
            ) : null}

            {/*                    Inicia Dialogo para agregar usuario   (((((((state.open))))))) lo abre */}

            <Dialog
              /*fullScreen */

              open={this.state.open}
              onClose={this.handleClose}
              aria-labelledby="form-dialog-title"
            >
              <div>
                <form
                  className={classes.container}
                  onSubmit={this.handleAdd}
                  autoComplete="off"
                >
                  <DialogTitle id="form-dialog-title">
                    Agregar Usuario Nuevo
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>Llenar datos</DialogContentText>
                    {/*** Nombre de USUARIO ***/}

                    <TextField
                      autoFocus
                      margin="dense"
                      id="name"
                      value={this.state.nombre}
                      onChange={(e) =>
                        this.setState({ nombre: e.target.value })
                      }
                      label="Nombre"
                      variant="outlined"
                      type="name"
                      fullWidth
                      required
                    />
                    {/*** CORREO ELECTRONICO ***/}
                    <TextField
                      margin="dense"
                      id="email"
                      value={this.state.email}
                      onChange={(e) =>
                        this.setState({ email: e.target.value.toLowerCase() })
                      }
                      label="Correo Electronico"
                      variant="outlined"
                      type="name"
                      fullWidth
                      required
                    />
                    {/*** CONTRASEÃ±A ***/}
                    <TextField
                      margin="dense"
                      id="name"
                      value={this.state.contra}
                      onChange={(e) =>
                        this.setState({ contra: e.target.value })
                      }
                      label="Contraseña/RFC"
                      variant="outlined"
                      type="name"
                      fullWidth
                      required
                    />
                    {/*** CONFIRMAR CONTRASEÃ±A ***/}
                    <TextField
                      margin="dense"
                      id="contra"
                      value={this.state.contra2}
                      onChange={(e) =>
                        this.setState({ contra2: e.target.value })
                      }
                      label="Contraseña/RFC"
                      variant="outlined"
                      type="name"
                      fullWidth
                      required
                    />
                    {/*** TIPO DE USUARIO ***/}
                    <TextField
                      style={{ textTransform: "capitalize" }}
                      margin="dense"
                      id="name"
                      select
                      label="Rol"
                      value={this.state.rolLabel}
                      onChange={(e) => {
                        this.setState({ rolLabel: e.target.value });
                      }}
                      variant="outlined"
                      fullWidth
                      required
                    >
                      {this.state.rol.map((option) => (
                        <MenuItem
                          key={option.value}
                          value={option.label}
                          style={{ textTransform: "capitalize" }}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                      {/*this.state.deCanela.map(e=> e.id)*/}
                    </TextField>
                  </DialogContent>

                  <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                      Cancelar
                    </Button>
                    <Button type="submit" variant="outlined" color="primary">
                      Guardar
                    </Button>
                  </DialogActions>
                </form>
              </div>
            </Dialog>

            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            ></div>

            <SnackBar
              open={this.state.guardado}
              exito={this.state.exito}
              handleClose={() => {
                this.setState({ guardado: false });
              }}
            />

            {/*                    Inicia Dialogo para EDITAR usuario   (((((((state.open2))))))) lo abre */}

            <Dialog
              /*fullScreen */

              open={this.state.open2}
              onClose={this.handleClose2}
              aria-labelledby="form-dialog-title"
            >
              <div>
                <form
                  className={classes.container}
                  onSubmit={this.editSubmit}
                  autoComplete="off"
                >
                  <DialogTitle id="form-dialog-title">
                    Editar Usuario
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>Llenar datos</DialogContentText>
                    {/*** Nombre de USUARIO ***/}
                    {this.state.nombre}
                    <TextField
                      autoFocus
                      margin="dense"
                      id="name"
                      value={this.state.nombreE}
                      onChange={(e) =>
                        this.setState({ nombreE: e.target.value })
                      }
                      label="Nombre"
                      variant="outlined"
                      type="name"
                      fullWidth
                      required
                    />
                    {/*** CORREO ELECTRONICO ***/}
                    {this.state.email}
                    <TextField
                      style={{ textTransform: "capitalize" }}
                      margin="dense"
                      id="email"
                      value={this.state.emailE}
                      onChange={(e) =>
                        this.setState({
                          emailE: e.target.value.toLowerCase(),
                        })
                      }
                      label="Correo Electronico"
                      variant="outlined"
                      type="name"
                      fullWidth
                      required
                    />
                    {/*** CONTRASEÃ±A ***/}
                    {this.state.contra}
                    <TextField
                      style={{ textTransform: "capitalize" }}
                      margin="dense"
                      id="name"
                      value={this.state.contraE}
                      onChange={(e) =>
                        this.setState({ contraE: e.target.value })
                      }
                      label="Contraseña/RFC"
                      variant="outlined"
                      type="name"
                      fullWidth
                      required
                    />
                    {/*** CONFIRMAR CONTRASEÃ±A ***/}
                    {this.state.contra2}
                    <TextField
                      style={{ textTransform: "capitalize" }}
                      margin="dense"
                      id="contra"
                      value={this.state.contra2E}
                      onChange={(e) =>
                        this.setState({ contra2E: e.target.value })
                      }
                      label="Contraseña/RFC"
                      variant="outlined"
                      type="name"
                      fullWidth
                      required
                    />
                    {/*** TIPO DE USUARIO ***/}
                    {this.state.rolLabel}
                    <TextField
                      style={{ textTransform: "capitalize" }}
                      margin="dense"
                      id="name"
                      select
                      label="Rol"
                      value={this.state.rolLabelE}
                      onChange={(e) => {
                        this.setState({ rolLabelE: e.target.value });
                      }}
                      variant="outlined"
                      fullWidth
                      required
                    >
                      {this.state.rol.map((option) => (
                        <MenuItem
                          key={option.value}
                          value={option.label}
                          style={{ textTransform: "capitalize" }}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                      {/*this.state.deCanela.map(e=> e.id)*/}
                    </TextField>
                  </DialogContent>

                  <DialogActions>
                    <Button
                      onClick={() => this.setState({ open2: false })}
                      color="primary"
                    >
                      Cancelar
                    </Button>
                    <Button type="submit" variant="outlined" color="primary">
                      Guardar
                    </Button>
                  </DialogActions>
                </form>
              </div>
            </Dialog>
          </div>
        ) : (
          <Roles />
        )}
      </div>
    );
  }
}
export default withStyles(styles)(Usuarios);
